import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Crop54Icon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_5_4"}/>
}
